const vimeoRegEx = /^\s*(?:https?:\/\/)?(?:www\.)?vimeo\.com\/([0-9]+)\s*$/
const youtubeRegEx = /^\s*(?:https?:\/\/)?(?:youtu\.be\/([_\-0-9a-zA-Z]{11,})|(?:www\.|m\.)?youtube\.com\/watch\?(?:[^&\s]*&)*v=([_\-0-9a-zA-Z]{11,})(?:&[^&\s]*)*)\s*$/

const youtube = 'youtube'
const vimeo = 'vimeo'

const getVideoDetails = (videoURL) => {
  let match = videoURL.match(vimeoRegEx)
  if (match && match.length >= 2) {
    return { type: vimeo, id: match[1] }
  }

  match = videoURL.match(youtubeRegEx)
  if (match) {
    for (let i = 1; i < match.length; i++) {
      if (match[i]) {
        return { type: youtube, id: match[i] }
      }
    }
  }
  return null
}

export default {
  getVideoDetails,
}
